import http from '../http'

export default {
  getSessions () {
    return http.get('/session')
  },
  getSessionMessages (id) {
    return http.get(`/session/${id}/messages`)
  },
  getSessionCount () {
    return http.get('/session/count')
  },
  exportSessions () {
    return http.get('/session/export', { responseType: 'blob' })
  }
}
